/**
 * Fix country/currency clicks that land on nested flag/label nodes.
 * Theme LocalizationSelector only checks event.target for
 * data-localization-item, so child clicks no-op after preventDefault.
 */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      var item = event.target && event.target.closest && event.target.closest('[data-localization-item]');
      if (!item) return;

      var selector = item.closest('localization-selector');
      if (!selector || !selector.contains(item)) return;

      // Theme handler already works when the button itself is the target.
      if (event.target === item) return;

      var input = selector.querySelector('[data-localization-input]');
      var form = selector.querySelector('form');
      var value = item.getAttribute('data-value');
      if (!input || !form || !value) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      input.value = value;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    },
    true
  );
})();
